export const getQuestionnaireEmailStorageKey = (questionnairePublicId: string) =>
    `questionnaire-email-${questionnairePublicId}`;
